export class CreateRoleRequest {
    'name';
    'permissionGrants';
    'accessConditions';
    'restoreAccountAccessCondition';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "permissionGrants",
            "baseName": "permissionGrants",
            "type": "Array<PermissionGrantInput>",
            "format": ""
        },
        {
            "name": "accessConditions",
            "baseName": "accessConditions",
            "type": "Array<AccessCondition>",
            "format": ""
        },
        {
            "name": "restoreAccountAccessCondition",
            "baseName": "restoreAccountAccessCondition",
            "type": "RestoreAccountAccessCondition",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateRoleRequest.attributeTypeMap;
    }
    constructor() {
    }
}
